import { FaHtml5 } from "react-icons/fa";
import { FaCss3 } from "react-icons/fa";
import { FaNodeJs } from "react-icons/fa6";
import { FaReact } from "react-icons/fa6";
import { SiTailwindcss } from "react-icons/si";
import { FaGitAlt } from "react-icons/fa";
import { DiNodejs } from "react-icons/di";
import { SiExpress } from "react-icons/si";
import { DiMongodb } from "react-icons/di";
import { FaFigma } from "react-icons/fa";
import { DiPhotoshop } from "react-icons/di";
import { SiAdobexd } from "react-icons/si";


export const skillArray = [
  { name: "HTML", icon: <FaHtml5 size={40} />, color: "#E34F26" },
  { name: "CSS", icon: <FaCss3 size={40} />, color: "#264de4" },
  { name: "JavaScript", icon: <FaNodeJs size={40} />, color: "#F7DF1E" },
  { name: "React", icon: <FaReact size={40} />, color: "#61DAFB" },
  { name: "Tailwind", icon: <SiTailwindcss size={40} />, color: "#38BDF8" },
  { name: "Git", icon: <FaGitAlt size={40} />, color: "#F05033" },
  { name: "Node.js", icon: <DiNodejs size={40} />, color: "#8CC84B" },
  { name: "Express", icon: <SiExpress size={40} />, color: "gray" },
  { name: "MongoDB", icon: <DiMongodb size={40} />, color: "#47A248" },
  { name: "Figma", icon: <FaFigma size={40} />, color: "#F24E1E" },
  { name: "Photoshop", icon: <DiPhotoshop size={40} />, color: "#31A8FF" },
  { name: "AdobeXD", icon: <SiAdobexd size={40} />, color: "#31A8FF" },

]